import { Dayjs } from 'dayjs';
import map from 'lodash/map';
import merge from 'lodash/merge';
import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';
import { AnyAction } from 'mobile/node_modules/redux';
import {
  ClinicNotesFilterOption,
  ClinicNotesFilterType,
  ClinicNotesListState,
  FilterDateTimeOptions
} from './types';

// Sort all unique note categories from list data to render as filter options
export const getClinicNotesFilterOptions = (
  state: ClinicNotesListState,
  action: AnyAction,
  initialDateRange: { from: Dayjs; to: Dayjs }
) => {
  const noteCategories = sortBy(
    map(uniqBy(action.payload.data, 'noteCategory'), category => {
      return {
        ...category,
        filterType: ClinicNotesFilterType.noteCategory,
        checked: false
      };
    }),
    (item: ClinicNotesFilterOption) => item.noteCategory
  );

  state.filterOptions = merge(
    {
      // providers,
      noteCategories,
      dateTime: [
        {
          id: FilterDateTimeOptions.ONE_MONTH,
          filterType: ClinicNotesFilterType.dateTime,
          value: FilterDateTimeOptions.ONE_MONTH,
          title: 'Last 30 Days',
          checked: false
        },
        {
          id: FilterDateTimeOptions.THREE_MONTHS,
          filterType: ClinicNotesFilterType.dateTime,
          value: FilterDateTimeOptions.THREE_MONTHS,
          title: 'Last 90 Days',
          checked: false
        },
        {
          id: FilterDateTimeOptions.ONE_YEAR,
          filterType: ClinicNotesFilterType.dateTime,
          value: FilterDateTimeOptions.ONE_YEAR,
          title: 'Last 360 Days',
          checked: false
        },
        {
          id: 'custom',
          filterType: ClinicNotesFilterType.dateRange,
          value: initialDateRange,
          title: 'Custom date range',
          checked: false
        }
      ]
    },
    state.filterOptions
  );
  return state.filterOptions;
};
